@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <ix-input
      [formControl]="control"
      [invalidText]="createInvalidText(control)"
      [ngClass]="{'ix-invalid': control.errors}"
      class="w-100"
      id="{{attribute.name}}">
      <ix-icon name="e-mail" size="16" slot="start"></ix-icon>
    </ix-input>
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
